import React, { Component, Fragment } from 'react'
import { Col, Container, Row} from 'react-bootstrap'

export class ProjectDetails extends Component {
  render() {
    return (
     <Fragment>
        <Container>
          <Row>
            <Col>
            <h1>Nahin</h1></Col>
          </Row>
        </Container>
     </Fragment>
    )
  }
}

export default ProjectDetails
